import { render, staticRenderFns } from "./GeneralSettingsLocale.vue?vue&type=template&id=2ae8d8cd&"
import script from "./GeneralSettingsLocale.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsLocale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports